export default "__VITE_ASSET__CdHEA7jg__"